import { createVNode as l, mergeProps as s } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/FolderClosedTwoTone.js";
import d from "../components/PfIcon.js";
const o = (e, r) => {
  const t = {
    ...e,
    ...r.attrs
  };
  return l(d, s(t, {
    icon: n
  }), null);
};
o.displayName = "FolderClosedTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
